import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik, useField } from "formik";

import { useDispatch } from "react-redux";

//Tabs

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import FormFields from "./FormFields"; // Import the new FormFields component

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const handleSubmit = (formValues) => {
  //console.log("firstName ", formValues?.firstName);
};

const TestModal = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  // Formik

  const formikSuper = useFormik({
    initialValues: {
      firstName: "", // Provide a default value for firstName
    },
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  const formikCorporateSuper = useFormik({
    initialValues: {
      CorporatefirstName: "", // Provide a default value for CorporatefirstName
    },
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  //Tabs

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newTabValue) => {
    setTabValue(newTabValue);
  };

  const handleBlur = (event) => {
    // Perform actions or validations when the TextField loses focus
    //console.log("Field blurred:", event.target.value);
  };

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Add Passenger
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <TextField
            name="firstName"
            id="firstName"
            label="firstName"
            value={formikSuper?.values?.firstName}
            onChange={formikSuper?.handleChange}
            error={
              formikSuper?.errors?.firstName && formikSuper?.touched?.firstName
            }
            helperText={
              formikSuper?.errors?.firstName &&
              formikSuper?.touched?.firstName &&
              formikSuper?.errors?.firstName
            }
            fullWidth
            variant="outlined"
            size="small"
          ></TextField>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <Box sx={{ width: "100%" }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                          <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            aria-label="basic tabs example"
                          >
                            <Tab label="Item One" {...a11yProps(0)} />
                            <Tab label="Item Two" {...a11yProps(1)} />
                            <Tab label="Item Three" {...a11yProps(2)} />
                          </Tabs>
                        </Box>
                        <CustomTabPanel value={tabValue} index={0}>
                          <TextField
                            name="firstName"
                            id="firstName"
                            label="firstName"
                            defaultValue={formikSuper?.values?.firstName}
                            onBlur={formikSuper?.handleBlur}
                            error={
                              formikSuper?.errors?.firstName &&
                              formikSuper?.touched?.firstName
                            }
                            helperText={
                              formikSuper?.errors?.firstName &&
                              formikSuper?.touched?.firstName &&
                              formikSuper?.errors?.firstName
                            }
                            fullWidth
                            variant="outlined"
                            size="small"
                          />
                        </CustomTabPanel>
                        <CustomTabPanel
                          value={tabValue}
                          index={1}
                        ></CustomTabPanel>
                        <CustomTabPanel value={tabValue} index={2}>
                          Item Three
                        </CustomTabPanel>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TestModal;
